import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { colors, fonts, media, mixins } from 'consumer-components';

export interface TableCellProps {
  content: React.ReactNode;
  heading?: boolean;
  scope?: 'col' | 'row'; // for a11y, identifies the scope of the tabble heading
  textAlign: 'left' | 'right';
}

const styles = StyleSheet.create({
  heading: {
    ...fonts.Roboto,
    ...mixins.paddingVertical(10),
    color: colors.clayPlus3,
    fontSize: 12,
    fontWeight: fonts.weight.bold,
    letterSpacing: 0.6,
  },
  alignLeft: {
    textAlign: 'left',
  },
  alignRight: {
    textAlign: 'right',
  },
  rowCell: {
    ...fonts.Roboto,
    ...mixins.padding(16, 4),
    color: colors.darkerGray,
    fontSize: 16,
    verticalAlign: 'middle',

    ':first-child': {
      paddingLeft: 0,
    },
    ':last-child': {
      paddingRight: 0,
    },

    [media.mobileMedium]: {
      fontSize: 14,
    },
  },
});

export default class TableCell extends React.PureComponent<TableCellProps> {
  render() {
    const { content, heading, scope, textAlign } = this.props;
    return heading ? (
      <th className={css(styles.heading, textAlign === 'left' ? styles.alignLeft : styles.alignRight)} scope={scope}>
        {content}
      </th>
    ) : (
      <td className={css(styles.rowCell, textAlign === 'left' ? styles.alignLeft : styles.alignRight)}>{content}</td>
    );
  }
}
